<template>

    <div class="or-services padding-top-50">
        <h2 class="title">
            {{info ? info['services-title'] : null}}
        </h2>
        <div class="layout-1200">
            <div class="service-cards flex-row row-space-between row-ver-center">
                <or-service-card @toFeedback="toFeedback" v-for="card in cards" :key="card.key" :options="card"/>
            </div>
            <div class="button flex-row flex-center padding-top-50">
                <or-button @click="toFeedback({focus: name, fill: undefined})" 
                           :options="{
                                        text: 'Нужна другая услуга',
                                        class: 'stroke-button',
                                        style: {
                                            width: '210px',
                                            height: '40px',
                                            borderRadius: '8px',
                                        },
                                        animation: 'anim-sub-button'
                                    }"/>
            </div>
        </div>
    </div>
    
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import orServiceCard from "./or-service-card.vue"
import orButton from "../../../global/or-button.vue"
export default {
    components: {orServiceCard, orButton},
    data() {
        return {
            cards: [
                {
                    key: 1,
                    title: 'Подбор огнеупоров',
                    text: ['Подготовим комплект материалов для', 'ремонта тепловых агрегатов'],
                    image: 'services_1',
                    redirect: 'feedback',
                },
                {
                    key: 2,
                    title: 'Поставка огнеупоров',
                    text: ['Поставим любые огнеупорные материалы','точно в необходимые вам сроки'],
                    image: 'services_2',
                    redirect: 'buyers',
                },
                {
                    key: 3,
                    title: 'Дизайн футеровки',
                    text: ['Составим проект футеровки под ваши','задачи и подготовим материалы'],
                    image: 'services_3',
                    redirect: 'feedback',
                },
            ]
        }
    },
    computed: {
        ...mapGetters({info: 'getInfo'})
    },
    methods: {
        toFeedback(data) {
            this.$emit('toFeedback', data)
        }
    }
}
</script>

<style scoped>
    .title {
        margin-bottom: 50px;
        font-size: 30px;
        line-height: 35px;
    }
    .button {
        width: 100%;
        padding-bottom: 50px;
    }
</style>